import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=7d156b3e&scoped=true"
import script from "./NotificationItem.vue?vue&type=script&lang=js"
export * from "./NotificationItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=7d156b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d156b3e",
  null
  
)

export default component.exports